import React, { Component, PropTypes } from 'react'
import { CategoryType } from 'types'
import Category from 'components/Category'
import CargosStore from 'stores/CargosStore'
import ParametersStore from 'stores/ParametersStore'
import CategoryStore from 'stores/CategoryStore'
import ButtonControl from 'components/ButtonControl'
import isMobile from 'ismobilejs'

import './Categories.scss'
import RouteStore from '../../stores/RouteStore'

const DESKTOP_VISIBLE_CATEGORIES_NUM = 14
const MOBILE_VISIBLE_CATEGORIES_NUM = 10

/**
 * Список категорий перевозок.
 */
class Categories extends Component {

    static propTypes = {
        categories: PropTypes.objectOf(CategoryType).isRequired,
    }
    
    state = {
        showAllCategories: false,
    }

    componentWillMount() {
        // TODO: Move to Actions!
        CargosStore.clearDeliveryCargos();
        CategoryStore.resetSelectedCategory();
        RouteStore.clearLocations()
        ParametersStore.clearDeliveryParameters()
    }
    
    showAllCategories = () => {
        this.setState({
            showAllCategories: true,
        })
    }

    render() {
        const visibleCategories = []
        const hiddenCategories = []
        let count = 0
        const limit = isMobile.tablet || isMobile.phone ? MOBILE_VISIBLE_CATEGORIES_NUM : DESKTOP_VISIBLE_CATEGORIES_NUM
        
        Object.keys(this.props.categories).forEach(id => {

            if (id === 'moving_cian') {
                return false;
            }
            
            const category = (
                <div className="Categories-item"
                     key={id}>
                    <Category category={this.props.categories[id]}/>
                </div>
            )
    
            if (count < limit) {
                visibleCategories.push(category)
            } else {
                hiddenCategories.push(category)
            }
            
            count++
        })

        return (
            <div className="Categories container">
                <div className="Categories-list row">
                    {visibleCategories}
                    {hiddenCategories}
                </div>
                {/*{this.state.showAllCategories === false ?
                    <div>
                        <div className="Categories-showAllTitle">У вас другой груз?</div>
                        <ButtonControl
                            className="Categories-showAllButton"
                            view="sky"
                            size="m"
                            onClick={this.showAllCategories}>
                            Смотреть все категории
                        </ButtonControl>
                    </div>
                : null}*/}
            </div>
        );
    }
}

export default Categories



// WEBPACK FOOTER //
// ./client/components/Categories/Categories.js